import { render, staticRenderFns } from "./update-work.vue?vue&type=template&id=4242dbea&scoped=true"
import script from "./update-work.vue?vue&type=script&lang=js"
export * from "./update-work.vue?vue&type=script&lang=js"
import style0 from "./update-work.vue?vue&type=style&index=0&id=4242dbea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4242dbea",
  null
  
)

export default component.exports